import React from 'react'
import PostCard from '../../components/PostCard/PostCard'
import LastBlock from '../../components/BasicBlock/BasicBlock'
import { graphql, useStaticQuery } from 'gatsby'
function BottomContent({ relatedCase, latestBlock }) {
    return (
        <div className="mt-14 xl:mt-24 ">
            {relatedCase?.clientCards?.cards.length > 0 && <div className="container">
                <div className="">
                    <h3 className="mb-10 inline-block">More case studies</h3>
                    <div className="grid gap-x-6 gap-y-10 md:grid-cols-3 md:gap-x-7">
                        {relatedCase?.clientCards?.cards?.map((card) => {
                            return (
                                <PostCard
                                    key={card.title}
                                    uri={card?.uri}
                                    title={card?.title}
                                    thumbnail={card?.featuredImage}
                                    description={card?.excerpt}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>}

            {latestBlock?.map((node, index) => {
                return <LastBlock key={index} {...node} />
            })}
        </div>
    )
}

export default BottomContent
